import React, { useState, useEffect, useRef } from "react";
import Header from '../../../Components/Header/header';
import Back from '../../../Components/back/back';
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { FaPlus, FaTrash } from 'react-icons/fa'; // Import the plus icon from react-icons
import Writing from '../../../Components/typewriter/typewriter';
import "react-phone-number-input/style.css";
import '../../../css/loader.css';
import config from '../../../Context/Config';
import { toJpeg } from 'html-to-image';
import logo from '../../../Components/Assets/logo.svg'
import segLogo from '../../../Components/Assets/seglogo.svg'
import Rocket from '../../../Components/rocket/rocket';
import NextBtnLoader from "../../../Components/loader/loader";
import FormInput from "../../../Components/formInput/formInput";
import FormInputTop from "../../../Components/formInput/formInput2";
import DobInput from "../../../Components/dobPicker/dobInput";
import SelectInput from "../../../Components/selectInput/select";
import TextInput from "../../../Components/textInput/textInput";
import BackgruseRedirectIfNotLoggedIn from '../../../Components/redirect/redirect';
import { compressImageForIOS } from "../../../Utils/compress";
import { checkTokenAndNavigate } from "../../../Utils/login";
import { getCityStateFromZip } from "../../../Utils/zip";
import MedicalPortalAccess from "../../../Components/selectInput/portal";
import DynamicCheckbox from "../../../Components/selectInput/consent";
import { languageOptions, genderOptions, emergencyRelationshipOptions, ethnicityOptions, raceOptions, maritalOptions, refractionsOptions, imagingOptions } from '../../../Utils/Options'
import { handleFamilyContentChanges, removeFamilyMember, validateFamilyMembers } from "../../../Utils/familyMembers";
import Paragraph from "../../../Components/paragraph/paragrah";
import Logo from '../../../Components/InfoDisplay/logo';
import SegLogoBanner from '../../../Components/InfoDisplay/segLogo'
import SegFooter from '../../../Components/InfoDisplay/segfooter'
import HeaderTitle from '../../../Components/InfoDisplay/header';
import RSIdemographics from "../../../Components/Demographics/rsiDemographics";
import SEGdemographics from "../../../Components/Demographics/segDemographics";
import Signature from "../../../Components/signature/signature";
import SignaturePopup from "../../../Components/signature/signaturePopup";
import { formattingDate } from "../../../Utils/formatDate";
import { useZoom } from "../../../Context/Zoom";
import DOBPickerInput from "../../../Components/dobPicker/dobPicker";
import FamilyMemberConsent from "../../../Components/familyMembers/familyMembers";
import { showAlertAndNavigate, showWarning } from "../../../Utils/swal";
import { autosave } from "../../../Utils/autosave";
import useBackLock from "../../../Utils/backLock"
import ABN from "../../../Components/abn/abn";
import SegimageConsentForm from "../../../Components/imageConsent/segImageConsent";
import RadioGroup from "../../../Components/radio/radio";
import optos from "../../../Components/Assets/optos.png";
import optosHeader from "../../../Components/Assets/optosHeader.png";
import Agree from '../../../Components/signature/showSignature'
import FinanicalPolicy from "../../../Components/financialPolicy/financialPolicy";
import PCMConsent from "../../../Components/privacyPolicy/pcmConsent";
import Insurance from "../../../Components/insurances/insurances";

const PatientRegistrationPageForm = () => {
    useBackLock();
    const { zoom, setZoom } = useZoom();
    const [nextLoader, setNextLoader] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const location = useLocation();
    const { openedViaLogin, show } = location.state || {};
    const [insuranceFormOpen, setInsuranceFormOpen] = useState(false);
    const dept_name = config.practice;
    BackgruseRedirectIfNotLoggedIn(openedViaLogin, 50, "/context-not-found");
    const navigate = useNavigate();
    const { chart, apptId } = useParams();
    const [pageTitle, setPageTitle] = useState('');
    const [currentPage, setCurrentPage] = useState(dept_name === 'seg' && show ? 5 : 1);
    console.log(currentPage)
    const [isLoading3, setIsLoading3] = useState(false);
    const [isLoading4, setIsLoading4] = useState(false);
    const [showSignaturePopup, setShowSignaturePopup] = useState(false);
    const taskRunRef = useRef(false);
    const pageRef = useRef(null);
    const abnRef = useRef(null);
    const optosRef = useRef(null);
    const rsiRef = useRef(null);
    const financeRef = useRef(null);
    const pcmRef = useRef(null);
    const pages = useRef([]);
    const [statusMonitor, setStatusMonitor] = useState(false);
    const [showPatientSignaturePage4, setShowPatientSignaturePage4] = useState(false);
    const [showPatientSignaturePage5, setShowPatientSignaturePage5] = useState(false);
    const [showPatientSignaturePage6, setShowPatientSignaturePage6] = useState(false);
    const [show_pcm, setShow_pcm] = useState(false);
    const [show_finance, setShow_finance] = useState(false);
    const [age, setAge] = useState("");
    const currentDate = new Date();
    const formatDate = (date) => {
        try {
            const formattedDate = formattingDate(date);
            return formattedDate
        } catch (err) {
            console.error('Error formatting date:', err.message);
        }
    };

    const formattedDate = formatDate(currentDate); // Formats current date
    const [PatientRegistrationFormData, setPatientRegistrationFormData] = useState({
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        ssn: "",
        gender: "",
        dob: "",
        email: "",
        cellphone: "",
        language: "",
        race: "",
        ethnicity: "",
        referredBy: "",
        familyDoctor: "",
        emergencyName: "",
        emergencyRelationship: "",
        emergencyPhone: "",
        consentToText: false,
        emailConsent: false,
        familyMembers: [
            { name: '', relationship: '', dob: '', mobile_number: '' },
        ],
        portal: null,
        originalPortal: null,
        homenumber: "",
        worknumber: "",
        subscription: null,
        family_ph_no: null,
        family_fax_no: null,
        insurance_provider: "",
        policy_number: "",
        subscriber_name: "",
        subscriber_dob: "",
        patient_signature: null,
        referrer_ph_no: null,
        referrer_fax_no: null,
        signed_date: formattedDate,
        lasik: {
            "Yes, I would like to learn more": null,
            "I am unsure, please provide more information": null,
            "No, I am not interested at this time": null
        },
        refractions: null,
        imaging_options: null,
        provider: null,
        amount: null,
        pcm_consent: "",
        insurance_data: [],
    });
    // Enhanced image loading with better error handling


    const [isEditing, setIsEditing] = useState({});
    const [localpatientid, setlocalpatientid] = useState("");
    const [invalidFields, setInvalidFields] = useState([]);
    const [fileUpload, setFileUpload] = useState(false);
    const [showAllPages, setShowAllPages] = useState(false);
    const [signatures, setSignatures] = useState({
        patient_signature: ""
    });
    const canvasRefs = {
        patient_signature: useRef(null),
    };

    const handleCheckboxChange = (category, item, value) => {
        setPatientRegistrationFormData(prevState => ({
            ...prevState,
            [category]: {
                ...prevState[category],
                [item]: value
            }
        }));
    };

    const updateSignatureData = (type) => {
        const canvas = canvasRefs[type].current;
        if (canvas) {
            const dataUrl = canvas.toDataURL(0.3);
            setSignatures((prev) => ({
                ...prev,
                [type]: dataUrl,
            }));
            setPatientRegistrationFormData((prev) => ({
                ...prev,
                [type]: dataUrl, // Temporarily store in original format
            }));
        }
    };

    const clearSignature = (type) => {
        const canvas = canvasRefs[type]?.current;

        if (canvas) {
            // Clear the canvas if it exists
            canvas.clear();
        }

        // Clear the signature data from states
        setSignatures((prev) => ({
            ...prev,
            [type]: "",
        }));

        setPatientRegistrationFormData((prev) => ({
            ...prev,
            [type]: "", // Remove signature from form data
        }));

        // Optionally, exit edit mode if in edit mode
        setIsEditing((prev) => ({
            ...prev,
            [type]: false,
        }));
    };

    const toggleEditMode = (type, editMode) => {
        clearSignature(type);
        setIsEditing((prev) => ({
            ...prev,
            [type]: editMode,
        }));
    };

    const handleCheckChange = (key, value) => {
        setPatientRegistrationFormData((prev) => ({
            ...prev,
            [key]: value, // Dynamically set the key with the value
        }));
    };


    const handleZipSearch = async () => {
        const zip = PatientRegistrationFormData.zip;
        const result = await getCityStateFromZip(zip);
        if (result) {
            setPatientRegistrationFormData({
                ...PatientRegistrationFormData,
                city: result.city,
                state: result.state,
            });
        } else {
            setPatientRegistrationFormData({
                ...PatientRegistrationFormData,
                city: '',
                state: '',
            });
        }
    }

    // Function to handle API call
    const runTask = async () => {
        setIsLoading4(true);
        if (taskRunRef.current) return; // Prevent running if task has already been executed
        taskRunRef.current = true;

        try {
            const response = await fetch(`${config.API_BASE_URL}/token_pat_data`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: config.accessToken,
                }
            });
            if (response.ok) {
                let data = await response.json();
                setPatientRegistrationFormData(prevState => ({
                    ...prevState, // Retain existing fields
                    firstName: data['firstname'] || "",
                    lastName: data['lastname'] || "",
                    address: data['address1'] || "",
                    gender: data['sex'] || "",
                    zip: data['zip'] || "",
                    city: data['city'] || "",
                    state: data['state'] || "",
                    cellphone: (data['mobilephone'] || "").toString().trim(),
                    language: data['language6392code'] || "",
                    email: data['email'] || "",
                    race: data?.race?.[0] || "",
                    emergencyName: data['contactname'] || "",
                    emergencyRelationship: data['contactrelationship'] || "",
                    emergencyPhone: (data['contactmobilephone'] || "").toString().trim(),
                    ssn: data['ssn'] || "",
                    portal: data['portalstatus']['registered'] || "",
                    insurance_data: data.insurances ?? prevState.insurance_data,
                    originalPortal: data['portalstatus']['registered'] || "",
                    emailConsent: data.db_data?.email_consent ?? false,
                    referredBy: data.db_data?.referred_by ?? "",
                    familyDoctor: data.db_data?.family_doctor ?? "",
                    dob: data['dob'] || prevState.dob, // Preserve existing value if not in `data`
                    ethnicity: (data?.ethnicitycodes?.[0]) || prevState.ethnicity,
                    familyMembers: data['family_data'] || prevState.familyMembers,
                    consentToText: data['consenttotext'] || prevState.consentToText,
                    homenumber: (data['homephone'] || "").toString().trim(),
                    worknumber: (data['workphone'] || "").toString().trim(),
                    subscription: data.db_data?.subscription === true ? true : data.db_data?.subscription === false ? false : "",
                    family_fax_no: (data.db_data?.family_fax_no || "").toString().trim(),
                    family_ph_no: (data.db_data?.family_ph_no || "").toString().trim(),
                    referrer_fax_no: (data.db_data?.referrer_fax_no || "").toString().trim(),
                    referrer_ph_no: (data.db_data?.referrer_ph_no || "").toString().trim(),
                    insurance_provider: (data.db_data?.insurance_provider || "").toString().trim(),
                    policy_number: (data.db_data?.policy_number || "").toString().trim(),
                    subscriber_name: (data.db_data?.subscriber_name || "").toString().trim(),
                    subscriber_dob: (data.db_data?.subscriber_dob || "").toString().trim(),
                    patient_signature: data.db_data?.patient_signature ?? "",
                }));
                setShow_pcm(data?.show_pcm ?? false);
                setShow_finance(data?.show_finance ?? false);
                setSignatures((prev) => ({
                    ...prev,
                    patient_signature: data.db_data?.patient_signature ?? ""
                }));
                if (data.db_data.patient_signature === "" || data.db_data.patient_signature === null || data.db_data.patient_signature === undefined) {
                    setShowSignaturePopup(true);
                }
            } else {

                showAlertAndNavigate(
                    "warning",
                    "Unauthorized",
                    "Your session expired. Redirecting to login...",
                    config.token
                );
            }
        } finally {
            // Reset loading state
            setIsLoading4(false);
        }
    };

    useEffect(() => {
        if (openedViaLogin && !taskRunRef.current) {
            checkTokenAndNavigate(runTask, navigate);
        }
    }, [openedViaLogin]);

    const handlePortalChange = (e) => {
        const { id, value } = e.target;

        setPatientRegistrationFormData((prev) => ({
            ...prev,
            [id]:
                id === "portal" || id === "subscribe"
                    ? value === "true"
                    : value,
        }));
    };


    const handleFamilyContentChange = (index, field, value) => {

        handleFamilyContentChanges({
            index,
            field,
            value,
            formData: PatientRegistrationFormData,
            setFormData: setPatientRegistrationFormData,
        });
    };

    const ButtonGroup = ({
        isSubmitted,
        currentPage,
        handleEdit,
        handleNext,
        handleFormSubmit,
        handleBack
    }) => {
        const buttonClass =
            "px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all";

        let targetPage = 3; // Default to page 3
        if (dept_name === 'rsi') {
            const trueCount = (show_pcm ? 1 : 0) + (show_finance ? 1 : 0);
            if (trueCount === 0) targetPage = 3;
            else if (trueCount === 1) targetPage = 4;
            else targetPage = 5;
        }

        console.log('ButtonGroup - currentPage:', currentPage, 'targetPage:', targetPage, 'show_pcm:', show_pcm, 'show_finance:', show_finance);

        const shouldShowRegisterButton = dept_name === 'rsi'
            ? (currentPage === targetPage)
            : ((currentPage === 3 && !show) || (currentPage === 4 && show));

        return <div className="flex justify-end space-x-2 p-5 pt-0">

            {shouldShowRegisterButton ? (
                <button onClick={handleFormSubmit} className={buttonClass}>
                    <i className="fas fa-user-plus mr-2"></i> Update Demographics
                </button>
            ) : (
                <>
                    {
                        (!show && currentPage !== 1) && (
                            <button
                                type="button"
                                onClick={handleBackClick}
                                className={buttonClass}
                                id="back"
                            >
                                <i className="fas fa-arrow-left mr-2"></i> Previous
                            </button>
                        )
                    }
                    <button
                        type="button"
                        onClick={handleNext}
                        className={buttonClass}
                        id="next"
                    >
                        <i className="fas fa-arrow-right mr-2"></i> Next
                    </button>
                </>

            )}
        </div>
    };

    useEffect(() => {
        const date = PatientRegistrationFormData.dob;
        const state = PatientRegistrationFormData.state;

        const calculateAge = date
            ? new Date().getFullYear() -
            new Date(date).getFullYear() -
            (new Date() <
                new Date(
                    new Date(date).setFullYear(new Date().getFullYear())
                )
                ? 1
                : 0)
            : null;

        setAge(calculateAge);

        setPatientRegistrationFormData((prev) => ({
            ...prev,
            age: calculateAge,
        }));

        const isMinor = (state === 'AL' && calculateAge < 19) || (state !== 'AL' && calculateAge < 18);

        const wasMinor = PatientRegistrationFormData.isMinor;
        const statusChanged = wasMinor !== undefined && wasMinor !== isMinor;

        setPatientRegistrationFormData((prev) => ({
            ...prev,
            isMinor,
        }));

        if (statusChanged && calculateAge !== null) {
            setShowSignaturePopup(true);
            setStatusMonitor(true);
        }

    }, [PatientRegistrationFormData.dob]);

    const handleAddMember = () => {
        const familyMembers = PatientRegistrationFormData.familyMembers;
        const lastMember = familyMembers[familyMembers.length - 1];

        // Check if the last member is completely empty
        const allEmpty = Object.values(lastMember).every(
            (value) => !value?.toString().trim()
        );

        if (allEmpty) {
            Swal.fire({
                title: "Incomplete Member",
                text: "Please fill in all required fields for the current family member before adding another.",
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });
            return; // Prevent adding new member
        }

        // Validate the last member
        const errorMsg = validateFamilyMembers([lastMember]);
        if (errorMsg) {
            Swal.fire({
                title: "Missing/Invalid Fields",
                text: errorMsg,
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });
            return; // Prevent adding new member
        }

        // Add a new empty member
        setPatientRegistrationFormData({
            ...PatientRegistrationFormData,
            familyMembers: [
                ...familyMembers,
                { name: "", relationship: "", dob: "", mobile_number: "" },
            ],
        });
    };

    const handleRemoveFamilyMember = (index) => {
        setPatientRegistrationFormData((prevData) => ({
            ...prevData,
            familyMembers: removeFamilyMember(prevData.familyMembers, index),
        }));
    };

    useEffect(() => {
        // Set the title based on the current page
        setPageTitle('Demographics');
    }, [setPageTitle]); // Run this effect whenever `currentPage` or `setTitle` changes

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [currentPage]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setPatientRegistrationFormData((prev) => ({
            ...prev,
            [id]: value,  // For other fields, update normally
        }));
    };

    const PAGE_WIDTH = 1200;  // target width
    const SCALE = 0.7;        // scale factor to shrink height visually

    async function capturePageAsImage() {
        try {
            let page;
            if (dept_name === 'rsi') {
                if (currentPage === 3) page = rsiRef.current;
                else if (currentPage === 4) page = show_pcm ? pcmRef.current : financeRef.current;
                else if (currentPage === 5) page = financeRef.current;
                else page = rsiRef.current;
            } else {
                page = currentPage === 3 ? pageRef.current : currentPage === 4 ? abnRef.current : optosRef.current;
            }
            const node = page;
            if (!node) throw new Error("Invalid page reference");

            // Save original styles
            const originalStyle = {
                width: node.style.width,
                height: node.style.height,
                overflow: node.style.overflow,
                transform: node.style.transform,
                transformOrigin: node.style.transformOrigin,
            };

            // Temporarily expand container and scale it
            node.style.width = `${PAGE_WIDTH}px`;
            node.style.height = "auto";
            node.style.overflow = "visible";
            node.style.transformOrigin = "top left";
            node.style.transform = `scale(${SCALE})`;

            // Wait for layout/rendering
            await new Promise((resolve) => setTimeout(resolve, 50));

            // Capture the scaled content
            const image = await toJpeg(node, {
                quality: 0.95,
                backgroundColor: "#FFFFFF",
                width: node.scrollWidth * SCALE,
                height: node.scrollHeight * SCALE,
                pixelRatio: 2, // sharper image
            });

            // Restore original styles
            node.style.width = originalStyle.width;
            node.style.height = originalStyle.height;
            node.style.overflow = originalStyle.overflow;
            node.style.transform = originalStyle.transform;
            node.style.transformOrigin = originalStyle.transformOrigin;
            pages.current.push(image);
            return image;
        } catch (error) {
            console.error("Error capturing page:", error);
            throw error;
        }
    }

    const PATTERNS = {
        ssn: /^\d{3}-\d{2}-\d{4}$|^\d{9}$/,
        email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        phone: (value, country = "US") => {
            if (/[a-zA-Z]/.test(value)) return false;
            const parsed = parsePhoneNumberFromString(value, country);
            return parsed?.isValid() || false;
        },
    };

    const validatePage1 = () => {
        // Define required fields
        const REQUIRED_FIELDS = [
            { field: "firstName", label: "First Name" },
            { field: "lastName", label: "Last Name" },
            { field: "address", label: "Address" },
            { field: "city", label: "City" },
            { field: "state", label: "State" },
            { field: "zip", label: "Zip" },
            { field: "cellphone", label: "Cell Phone" },
            { field: "dob", label: "DOB" },
            { field: "gender", label: "Gender" },
        ];

        // Reset invalid fields
        setInvalidFields([]);
        const invalidFields = [];

        // Validate required fields
        REQUIRED_FIELDS.forEach(({ field, label }) => {
            const value = PatientRegistrationFormData[field];
            if (!String(value || "").trim()) {
                invalidFields.push(label);
            }
        });

        // Emergency fields validation
        const { cellphone, ssn, dob, worknumber, homenumber } = PatientRegistrationFormData;

        if (dob) {
            const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
            if (!dobRegex.test(dob)) {
                invalidFields.push("DOB");
            } else {
                const [month, day, year] = dob.split("/").map(Number);
                const dobDate = new Date(year, month - 1, day);
                const today = new Date();
                const minDate = new Date(today.getFullYear() - 125, today.getMonth(), today.getDate());

                if (dobDate > today || dobDate < minDate) {
                    invalidFields.push("DOB");
                }
            }
        }

        // Validate cell phone
        if (!PATTERNS.phone(cellphone)) {
            invalidFields.push("Cell Phone");
        }

        // Validate SSN
        if (ssn && !PATTERNS.ssn.test(ssn)) {
            invalidFields.push("SSN");
        }

        if (dept_name === 'seg' && homenumber && !PATTERNS.phone(homenumber)) {
            invalidFields.push("Home Phone");
        }

        if (dept_name === 'seg' && worknumber && !PATTERNS.phone(worknumber)) {
            invalidFields.push("Work Phone");
        }

        // If there are invalid fields, show an alert
        if (invalidFields.length > 0) {
            setInvalidFields(invalidFields);

            Swal.fire({
                title: "Missing or Invalid Fields",
                text: `Please fill out or correct the following fields:\n- ${invalidFields.join("\n- ")}`,
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });

            return false; // Indicate invalid form
        }
        return true; // Indicate valid form
    };

    const validatePage2 = () => {


        const REQUIRED_FIELDS = [];

        if (dept_name === 'rsi' && !PatientRegistrationFormData.familyDoctor) {
            REQUIRED_FIELDS.push({ field: "familyDoctor", label: "Family Doctor" });
        }

        if (dept_name === 'rsi' && !PatientRegistrationFormData.referredBy) {
            REQUIRED_FIELDS.push({ field: "referredBy", label: "Referred By" });
        }

        // Reset invalid fields
        setInvalidFields([]);
        const invalidFields = [];
        // Validate required fields
        REQUIRED_FIELDS.forEach(({ field, label }) => {
            if (!PatientRegistrationFormData[field]?.trim()) {
                invalidFields.push(label);
            }
        });


        // Emergency fields validation
        const { portal, email, emergencyPhone, emergencyName, emergencyRelationship, family_fax_no, family_ph_no, referrer_fax_no, referrer_ph_no } = PatientRegistrationFormData;
        const emergencyFields = [
            { value: emergencyName, label: "Emergency Name" },
            { value: emergencyRelationship, label: "Emergency Relationship" },
            { value: emergencyPhone, label: "Emergency Phone" },
        ];

        const filledEmergencyFields = emergencyFields.filter(({ value }) => value?.trim()).length;
        if (filledEmergencyFields > 0 && filledEmergencyFields < emergencyFields.length) {
            emergencyFields.forEach(({ value, label }) => {
                if (!value?.trim()) invalidFields.push(label);
            });
        }

        // Validate Emergency Phone
        if (emergencyPhone && !PATTERNS.phone(emergencyPhone)) {
            invalidFields.push("Emergency Phone");
        }

        if (referrer_fax_no && !PATTERNS.phone(referrer_fax_no)) {
            invalidFields.push("Referrer Fax Number");
        }

        // Validate email
        if (portal === true && (!email || !PATTERNS.email.test(email))) {
            invalidFields.push("Email");
        } else if (email && !PATTERNS.email.test(email)) {
            invalidFields.push("Email");
        }

        if (dept_name === 'seg' && family_ph_no && !PATTERNS.phone(family_ph_no)) {
            invalidFields.push("Family Phone Number");
        }
        if (dept_name === 'seg' && family_fax_no && !PATTERNS.phone(family_fax_no)) {
            invalidFields.push("Family Fax Number");
        }
        if (dept_name === 'seg' && referrer_ph_no && !PATTERNS.phone(referrer_ph_no)) {
            invalidFields.push("Referrer Phone Number");
        }

        if (invalidFields.length > 0) {
            setInvalidFields(invalidFields);

            Swal.fire({
                title: "Missing or Invalid Fields",
                text: `Please fill out or correct the following fields:\n- ${invalidFields.join("\n- ")}`,
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });

            return false; // Indicate invalid form
        }
        return true; // Indicate valid form

    }

    const validatePage4 = () => {
        setInvalidFields([]);
        const invalidFields = [];
        const { refractions } = PatientRegistrationFormData;

        if (dept_name === 'seg' && !refractions) {
            invalidFields.push("Refractions Option");
        }
        if (dept_name === 'seg' && !showPatientSignaturePage5) {
            invalidFields.push("Imaging Signature");
        }

        if (invalidFields.length > 0) {
            setInvalidFields(invalidFields);

            Swal.fire({
                title: "Missing or Invalid Fields",
                text: `Please fill out or correct the following fields:\n- ${invalidFields.join("\n- ")}`,
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });

            return false; // Indicate invalid form
        }
        return true; // Indicate valid form
    }

    const validatePage5 = () => {
        setInvalidFields([]);
        const invalidFields = [];
        const { imaging_options } = PatientRegistrationFormData;

        if (dept_name === 'seg' && !imaging_options) {
            invalidFields.push("Imaging Options");
        }
        if (dept_name === 'seg' && show && !showPatientSignaturePage5) {
            invalidFields.push("Agree and Sign");
        }

        if (dept_name === 'rsi' && !showPatientSignaturePage5) {
            invalidFields.push("Financial Policy Signature");
        }

        if (invalidFields.length > 0) {
            setInvalidFields(invalidFields);

            Swal.fire({
                title: "Missing or Invalid Fields",
                text: `Please fill out or correct the following fields:\n- ${invalidFields.join("\n- ")}`,
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });

            return false; // Indicate invalid form
        }
        return true; // Indicate valid form
    }

    const validatePage3 = () => {
        setInvalidFields([]);
        const invalidFields = [];
        const { familyMembers, lasik } = PatientRegistrationFormData;

        if (dept_name === 'seg'  && (age >=18 && age <=50) && !lasik["Yes, I would like to learn more"] && !lasik["I am unsure, please provide more information"] && !lasik["No, I am not interested at this time"]) {
            invalidFields.push("Lasik Interest");
        }

        if (dept_name === 'seg' && !showPatientSignaturePage5) {
            invalidFields.push("Patient Signature");
        }

        const result = validateFamilyMembers(familyMembers);
        if (result) {
            invalidFields.push(result);
        }

        if (invalidFields.length > 0) {
            setInvalidFields(invalidFields);

            Swal.fire({
                title: "Missing or Invalid Fields",
                text: `Please fill out or correct the following fields:\n- ${invalidFields.join("\n- ")}`,
                icon: "warning",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });

            return false; // Indicate invalid form
        }
        return true; // Indicate valid form
    }

    const handleEdit = (e) => {
        setCurrentPage(1);
        setIsSubmitted(false);
    }

    const update_database = async () => {
        const response = await fetch(`${config.API_BASE_URL}/update_db`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: config.accessToken,

            },
            body: JSON.stringify({
                form: PatientRegistrationFormData,
                show_pcm: show_pcm,
                show_finance: show_finance
            }),
        });
        if (response.ok) {
            const data = await response.json();
            if (data?.presigned_url?.urls) {
                return data.presigned_url;
            }
            if (data?.presigned_url?.url) {
                return {
                    urls: [data.presigned_url.url],
                    keys: data.presigned_url.key ? [data.presigned_url.key] : [],
                    chart: data.presigned_url.chart
                };
            }
            if (data?.urls) {
                return data;
            }
            return data;
        }
        else {
            if (response.status === 401) {
                Swal.fire({
                    icon: "warning",
                    title: "Unauthorized",
                    text: "Your session expired while updating demographics, click on 'Restore Session' to continue and submit the form again.",
                    confirmButtonText: "Restore Session",
                    allowOutsideClick: false,
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        // Call the refreshToken function when the "Refresh Token" button is clicked
                        update_database()
                    }
                });
            } else if (response.status === 403) {
                Swal.fire({
                    icon: "warning",
                    title: "Forbidden",
                    text: "You don't have permission to update demographics.",
                    confirmButtonText: "Close",
                    allowOutsideClick: false,
                });
            } else if (response.status === 500) {
                Swal.fire({
                    icon: "error",
                    title: "Server Error",
                    text: "There was a server error while updating demographics. Please try again later.",
                    confirmButtonText: "Close",
                    allowOutsideClick: false,
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "There was an issue while updating demographics. Please try again later.",
                    confirmButtonText: "Close",
                    allowOutsideClick: false,
                });
            }
        }
    }

    const handleLastPage = async () => {
        const image = await capturePageAsImage();
        return image;
    };

    // iOS-compatible upload function
    const uploadImageIOS = async (base64Image, url, maxRetries = 3) => {

        // Compress image first
        const compressedImage = await compressImageForIOS(base64Image, 0.8, 1200);

        // Convert to binary
        const base64Data = compressedImage.replace(/^data:image\/\w+;base64,/, "");
        const binaryData = atob(base64Data);
        const arrayBuffer = new Uint8Array(binaryData.length);

        for (let i = 0; i < binaryData.length; i++) {
            arrayBuffer[i] = binaryData.charCodeAt(i);
        }

        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {

                const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });

                // Try fetch first
                try {
                    const uploadResponse = await fetch(url, {
                        method: "PUT",
                        body: blob,
                        headers: {
                            "Content-Type": "image/jpeg",
                        },
                        keepalive: false,
                        cache: 'no-cache',
                    });

                    if (uploadResponse.ok) {
                        return uploadResponse;
                    } else {
                        throw new Error(`Fetch failed with status: ${uploadResponse.status}`);
                    }
                } catch (fetchError) {

                    // Fallback to XMLHttpRequest
                    const uploadResponse = await new Promise((resolve, reject) => {
                        const xhr = new XMLHttpRequest();

                        xhr.upload.addEventListener('progress', (e) => {
                            if (e.lengthComputable) {
                                const percentComplete = (e.loaded / e.total) * 100;
                            }
                        });

                        xhr.addEventListener('load', () => {
                            if (xhr.status >= 200 && xhr.status < 300) {
                                resolve(xhr);
                            } else {
                                reject(new Error(`XHR failed with status: ${xhr.status}`));
                            }
                        });

                        xhr.addEventListener('error', () => reject(new Error('XHR network error')));
                        xhr.addEventListener('abort', () => reject(new Error('XHR upload cancelled')));

                        xhr.open('PUT', url);
                        xhr.setRequestHeader('Content-Type', 'image/jpeg');
                        xhr.timeout = 120000; // 2 minutes
                        xhr.send(blob);
                    });

                    return uploadResponse;
                }

            } catch (error) {

                if (attempt === maxRetries) {
                    throw error;
                }

                // Wait before retry
                const delay = Math.pow(2, attempt) * 1000;
                await new Promise(resolve => setTimeout(resolve, delay));
            }
        }
    };

    // Main Upload Function - Updated handleFormSubmit section
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        let lastPage;
        if (dept_name === 'rsi') {
            lastPage = show_pcm && show_finance ? 5 : (show_pcm || show_finance ? 4 : 3);
        } else {
            lastPage = show ? 4 : 3;
        }
        if (currentPage === lastPage) {
            const validate = validateForm(currentPage);
            if (!validate) {
                return;
            }
        }
        if (lastPage === 3 && !show) {
            setShowAllPages(true);
        }
        setFileUpload(true);

        try {
            const originalZoom = zoom;
            // Reset zoom to 100% before capture
            setZoom(1);
            // Capture the last page

            const capturedPage = await handleLastPage();
            setZoom(originalZoom);


            // Update database and get presigned URLs
            const { urls } = await update_database();
            if (!urls || urls.length === 0) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "No URLs returned from the server. Please try again later.",
                    confirmButtonText: "Close",
                    allowOutsideClick: false,
                });
                return;
            }

            // iOS-optimized upload process
            const uploadPromises = async () => {
                const imagesList = pages.current;
                const uploadTasks = urls.map(async (url, index) => {
                    let base64Image;
                    let fileIndexName;

                    if (dept_name === "rsi") {
                        try {
                            if (index === 0) {
                                base64Image = imagesList[0];
                                fileIndexName = 'demographics';
                            } else if (show_pcm && index === 1) {
                                base64Image = imagesList[1];
                                fileIndexName = 'pcm_demo';
                            } else if (show_finance && index === (show_pcm ? 2 : 1)) {
                                base64Image = imagesList[show_pcm ? 2 : 1];
                                fileIndexName = 'financial';
                            }

                            await uploadImageIOS(base64Image, url);

                            return { success: true, url, fileIndexName };

                        } catch (error) {
                            console.error(`Upload failed for ${fileIndexName}:`, error.message);
                            return { success: false, url, error, fileIndexName };
                        }
                    }
                    if (dept_name === "seg") {
                        try {
                            if (index === 0) {
                                base64Image = show ? imagesList[1] : capturedPage;
                                fileIndexName = 'demographics';
                            } else if (index === 1) {
                                base64Image = capturedPage;
                                fileIndexName = 'abn';
                            } else if (index === 2) {
                                base64Image = imagesList[0];
                                fileIndexName = 'optos';
                            }

                            // Use iOS-compatible upload
                            await uploadImageIOS(base64Image, url);


                            return { success: true, url, fileIndexName };

                        } catch (error) {
                            console.error(`Upload failed for ${fileIndexName}:`, error.message);
                            return { success: false, url, error, fileIndexName };
                        }
                    }

                }
                )

                // Process uploads with some concurrency but not all at once (iOS memory management)
                const results = [];
                const batchSize = 2; // Process 2 uploads at a time

                for (let i = 0; i < uploadTasks.length; i += batchSize) {
                    const batch = uploadTasks.slice(i, i + batchSize);
                    const batchResults = await Promise.all(batch);
                    results.push(...batchResults);

                    // Small delay between batches for iOS
                    if (i + batchSize < uploadTasks.length) {
                        await new Promise(resolve => setTimeout(resolve, 500));
                    }
                }

                return results;
            };

            const results = await uploadPromises();
            const failedUploads = results.filter((result) => !result.success);

            if (failedUploads.length > 0) {
                console.error('Failed uploads:', failedUploads);

                const failedFileNames = failedUploads.map((fail) => fail.fileIndexName || 'Unknown').join(', ');

                Swal.fire({
                    icon: "error",
                    title: "Upload Failed",
                    text: `Some files failed to upload: ${failedFileNames}`,
                    html: `
                      <div style="text-align: left;">
                        <p><strong>Failed files:</strong> ${failedFileNames}</p>
                        <p style="font-size: 12px; color: #666;">
                          This may be due to network issues or file size. The upload will be retried.
                        </p>
                      </div>
                    `,
                    confirmButtonText: "Retry",
                    cancelButtonText: "Cancel",
                    showCancelButton: true,
                    allowOutsideClick: false,
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        // Retry after short delay
                        setTimeout(() => handleFormSubmit(e), 1000);
                    }
                });
            } else {

                Swal.fire({
                    icon: "success",
                    title: "Upload Complete",
                    text: "File has been uploaded successfully!",
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                }).then(() => {
                    navigate(`/form-submission-success`, { state: { openedViaLogin: true } });
                });
            }

        } catch (error) {
            console.error('Form submission error:', error);

            await Swal.fire({
                icon: "error",
                title: "Upload Failed",
                text: `Error: ${error.message}`,
                confirmButtonText: "Retry",
                cancelButtonText: "Cancel",
                showCancelButton: true,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    setTimeout(() => handleFormSubmit(e), 1000);
                }
            });
        } finally {
            setFileUpload(false);
        }
    };

    const validateForm = (page) => {
        switch (page) {
            case 1:
                return validatePage1()
            case 2:
                return validatePage2();
            case 3:
                return validatePage3();
            case 4:
                return validatePage4();
            case 5:
                return validatePage5();
            default:
                return true;
        }
    };

    const handleNext = async (e) => {
        try {
            e.preventDefault();

            if (insuranceFormOpen) {
                showWarning('Insurance Form Open', 'Please save or close your insurance changes before proceeding.');
                return;
            }

            if (!validateForm(currentPage)) {
                return;
            }

            // setIsNext(true);
            setNextLoader(true);
            await autosave('demographics', PatientRegistrationFormData);
            // Capture the page using the latest state update
            if (currentPage >= 3) {
                if (currentPage === 3) {
                    setShowAllPages(true);
                }
                await capturePageAsImage();
            }
            setShowAllPages(false);
            setNextLoader(false);
            // Use functional update to ensure you get the latest state
            if (currentPage === 5 && show) {
                setCurrentPage(1);  // Move to page 1 if currently on page 5 and show is true
            }
            else {
                setCurrentPage((prev) => {
                    return prev + 1;
                });
            }


        } finally {
            // setIsNext(false);
            setNextLoader(false);
        }
    };

    const handleBackClick = () => {
        if (currentPage === 1 && !show) {
            return;
        }
        else if (insuranceFormOpen) {
            showWarning('Insurance Form Open', 'Please save or close your insurance changes before proceeding.');
            return;
        }
        else if (show && currentPage === 1) {
            setCurrentPage(5);  // Decrement the current page for pages 2, 3, 4, etc.
        }
        else {
            setCurrentPage(currentPage - 1);  // Decrement the current page for pages 2, 3, 4, etc.
        }
    };

    const handleSignaturePopupClose = () => {
        setShowSignaturePopup(false);
        if (statusMonitor && show) {
            setCurrentPage(5)
        }
    };

    const handleSignatureSave = (fieldName, signatureData, fullName) => {
        setPatientRegistrationFormData((prev) => ({
            ...prev,
            [fieldName]: signatureData,
        }));
        setSignatures((prev) => ({
            ...prev,
            [fieldName]: signatureData,
        }));

        setShowSignaturePopup(false);
    };

    return (
        <div className="min-h-screen flex justify-center bg-gray-50">
            <div className="min-h-screen flex flex-col bg-white">
                {isLoading4 && (
                    <Writing />
                )}
                {nextLoader && (
                    <NextBtnLoader />
                )}
                {fileUpload && (
                    <Rocket />
                )}

                <SignaturePopup
                    isOpen={showSignaturePopup}
                    onClose={handleSignaturePopupClose}
                    onSave={handleSignatureSave}
                    firstName={PatientRegistrationFormData.firstName}
                    lastName={PatientRegistrationFormData.lastName}
                    isMinor={PatientRegistrationFormData.isMinor}
                    fieldName={"patient_signature"}
                />
                {
                    config.practice === 'rsi' && (
                        <RSIdemographics
                            pageTitle={pageTitle}
                            Header={Header}
                            currentPage={currentPage}
                            Back={Back}
                            handleBackClick={handleBackClick}
                            pageRef={rsiRef}
                            Logo={Logo}
                            logo={logo}
                            Head={HeaderTitle}
                            FormInput={FormInput}
                            DobInput={DobInput}
                            TextInput={TextInput}
                            SelectInput={SelectInput}
                            DynamicCheckbox={DynamicCheckbox}
                            MedicalPortalAccess={MedicalPortalAccess}
                            Paragraph={Paragraph}
                            ButtonGroup={ButtonGroup}
                            FaTrash={FaTrash}
                            FaPlus={FaPlus}
                            PatientRegistrationFormData={PatientRegistrationFormData}
                            setPatientRegistrationFormData={setPatientRegistrationFormData}
                            handleInputChange={handleInputChange}
                            handlePortalChange={handlePortalChange}
                            handleZipSearch={handleZipSearch}
                            handleFamilyContentChange={handleFamilyContentChange}
                            handleRemoveFamilyMember={handleRemoveFamilyMember}
                            handleAddMember={handleAddMember}
                            genderOptions={genderOptions}
                            languageOptions={languageOptions}
                            ethnicityOptions={ethnicityOptions}
                            raceOptions={raceOptions}
                            emergencyRelationshipOptions={emergencyRelationshipOptions}
                            invalidFields={invalidFields}
                            nextLoader={nextLoader}
                            isSubmitted={isSubmitted}
                            fileUpload={fileUpload}
                            handleEdit={handleEdit}
                            handleNext={handleNext}
                            handleFormSubmit={handleFormSubmit}
                            validateForm={validateForm}
                            showAllPages={showAllPages}
                            handleCheckChange={handleCheckChange}
                            DOBPickerInput={DOBPickerInput}
                            FamilyMemberConsent={FamilyMemberConsent}
                            FinanicalPolicy={FinanicalPolicy}
                            PCMConsent={PCMConsent}
                            Agree={Agree}
                            formattedDate={formattedDate}
                            showPatientSignaturePage4={showPatientSignaturePage4}
                            showPatientSignaturePage5={showPatientSignaturePage5}
                            setShowPatientSignaturePage4={setShowPatientSignaturePage4}
                            setShowPatientSignaturePage5={setShowPatientSignaturePage5}
                            signatures={signatures}
                            financeRef={financeRef}
                            pcmRef={pcmRef}
                            show_pcm={show_pcm}
                            show_finance={show_finance}
                            pages={pages}
                            Insurance={Insurance}
                            onFormStateChange={setInsuranceFormOpen}
                        />
                    )}

                {
                    config.practice === 'seg' && (
                        <SEGdemographics
                            pageTitle={pageTitle}
                            Header={Header}
                            currentPage={currentPage}
                            Back={Back}
                            handleBackClick={handleBackClick}
                            pageRef={pageRef}
                            SegLogoBanner={SegLogoBanner}
                            logo={segLogo}
                            FormInput={FormInput}
                            FormInputTop={FormInputTop}
                            DobInput={DobInput}
                            TextInput={TextInput}
                            SelectInput={SelectInput}
                            DynamicCheckbox={DynamicCheckbox}
                            MedicalPortalAccess={MedicalPortalAccess}
                            Paragraph={Paragraph}
                            ButtonGroup={ButtonGroup}
                            FaTrash={FaTrash}
                            FaPlus={FaPlus}
                            PatientRegistrationFormData={PatientRegistrationFormData}
                            setPatientRegistrationFormData={setPatientRegistrationFormData}
                            handleInputChange={handleInputChange}
                            handlePortalChange={handlePortalChange}
                            handleZipSearch={handleZipSearch}
                            handleFamilyContentChange={handleFamilyContentChange}
                            handleRemoveFamilyMember={handleRemoveFamilyMember}
                            handleAddMember={handleAddMember}
                            genderOptions={genderOptions}
                            languageOptions={languageOptions}
                            ethnicityOptions={ethnicityOptions}
                            maritalOptions={maritalOptions}
                            raceOptions={raceOptions}
                            emergencyRelationshipOptions={emergencyRelationshipOptions}
                            invalidFields={invalidFields}
                            nextLoader={nextLoader}
                            isSubmitted={isSubmitted}
                            fileUpload={fileUpload}
                            handleEdit={handleEdit}
                            handleNext={handleNext}
                            handleFormSubmit={handleFormSubmit}
                            validateForm={validateForm}
                            Signature={Signature}
                            signatures={signatures}
                            canvasRefs={canvasRefs}
                            updateSignatureData={updateSignatureData}
                            clearSignature={clearSignature}
                            toggleEditMode={toggleEditMode}
                            isEditing={isEditing}
                            formattedDate={formattedDate}
                            showAllPages={showAllPages}
                            handleCheckboxChange={handleCheckboxChange}
                            SegFooter={SegFooter}
                            handleCheckChange={handleCheckChange}
                            DOBPickerInput={DOBPickerInput}
                            FamilyMemberConsent={FamilyMemberConsent}
                            show={show}
                            ABN={ABN}
                            SegimageConsentForm={SegimageConsentForm}
                            RadioGroup={RadioGroup}
                            HeaderTitle={HeaderTitle}
                            imagingOptions={imagingOptions}
                            refractionsOptions={refractionsOptions}
                            age={age}
                            showPatientSignaturePage4={showPatientSignaturePage4}
                            showPatientSignaturePage5={showPatientSignaturePage5}
                            showPatientSignaturePage6={showPatientSignaturePage6}
                            setShowPatientSignaturePage5={setShowPatientSignaturePage5}
                            setShowPatientSignaturePage6={setShowPatientSignaturePage6}
                            setShowPatientSignaturePage4={setShowPatientSignaturePage4}
                            Agree={Agree}
                            abnRef={abnRef}
                            optosRef={optosRef}
                            optosHeader={optosHeader}
                            optos={optos}
                            Logo={Logo}
                            Insurance={Insurance}
                            onFormStateChange={setInsuranceFormOpen}
                        />
                    )}
            </div >
        </div>
    );
};

export default PatientRegistrationPageForm;



